import * as React from "react";
import TextField from "@mui/material/TextField";
import styled from "styled-components";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
const WhiteBorderTextField = styled(TextField)`
  & label.Mui-focused {
    color: var(--text_secondary_light) !important;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #ff9800;
    }
    background: "rgb(232, 241, 250)";
    border-color: #ff0000; /* Add this line to set the border color */
  }

  & .MuiInputLabel-root {
    font-weight: bold; /* Change font weight to bold */
  }

`;
export default function UtsavTextField({
  label,
  name,
  value,
  type = "text",
  autoComplete = "off",
  setProps,
  inputProps,
  startAdornment,
  index,
  multiline = false,
  endAdornment,
  endAdornmentClick,
  rows = 1,
  showPassword,
  disabled,
  important = false,
  error = false
}) {
  return <WhiteBorderTextField label={label} variant="outlined" value={value} name={name}
  // color={theme.palette.utsavWhite}
  // type={type}
  type={showPassword ? "text" : type} autoComplete={autoComplete} fullWidth={true} InputProps={{
    style: {
      borderRadius: "10px"
    },
    startAdornment: startAdornment && <InputAdornment position="start">{startAdornment}</InputAdornment>,
    endAdornment: type !== "password" && endAdornment && !error ? <InputAdornment position="end" onClick={() => endAdornmentClick(index)}>
              {endAdornment}
            </InputAdornment> :
    // : type !== "password" && endAdornment && error ? (
    //   <InputAdornment position="end">
    //     <ErrorOutlineOutlinedIcon color="error" />
    //     {endAdornment}
    //   </InputAdornment>
    // ) : type !== "password" && !endAdornment && error ? (
    //   <InputAdornment position="end">
    //     <ErrorOutlineOutlinedIcon color="error" />
    //   </InputAdornment>
    // )
    type === "password" && <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" onClick={() => endAdornmentClick()}
      // onMouseDown={handleMouseDownPassword}
      edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
  }} inputProps={inputProps} onChange={e => {
    setProps(e, index);
  }} rows={rows} margin="normal" multiline={multiline} disabled={disabled} required={important} helperText={error ? `${name} is required` : ""} error={error} data-sentry-element="WhiteBorderTextField" data-sentry-component="UtsavTextField" data-sentry-source-file="UtsavTextField.jsx" />;
}